module.exports = __webpack_public_path__ + "static/pm-abiy-4-4f59f9393c6664729a61c001855cd10e.jpg";